module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_family@2x-5e35637ad2c7ac59e98680cb81521b26.webp";